// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3s1wo","content":"ManualTimeModal_content__y18vw"};